import {
  Box,
  Card,
  CardHeader,
  Heading
} from "grommet";
import React from "react";
import { useTitle } from "react-use";
// import * as r from "../../routes";
import "./Settings.scss";

interface SettingsProps {}

const Settings: React.FC<SettingsProps> = () => {
  useTitle("Settings | Due");
  // const dispatch = useDispatch();
  // const { accounts, loading } = useAccounts();

  return (
    <Box align="start" width="1150px" gap="medium" style={{ borderRadius: 6 }}>
      <Heading level="2" color="white">
        Settings
      </Heading>
      <Box direction="row" gap="medium" fill="horizontal">
        <Box>
          <Card background="white" pad={{ vertical: "medium" }} width="200px">
            <CardHeader pad={{ horizontal: "medium", bottom: "small" }}>
              <Heading level="3">General</Heading>
            </CardHeader>
            {/* <NavButton active>Security</NavButton>
            <NavButton>Restrictions</NavButton>
            <NavButton>Profile</NavButton>
            <NavButton>Referrals</NavButton> */}
          </Card>

          <Card
            background="white"
            width="200px"
            margin={{ top: "small" }}
            pad={{ vertical: "medium" }}
          >
            <CardHeader pad={{ horizontal: "medium", bottom: "small" }}>
              <Heading level="3">Accounts</Heading>
            </CardHeader>
            {/* <NavButton>Retirement</NavButton>
            <NavButton>Fun Fund</NavButton> */}
          </Card>
        </Box>

        <Card background="white" flex="grow">
        </Card>
      </Box>
    </Box>
  );
};

// const NavButton = ({
//   children,
//   active,
// }: {
//   children: React.ReactNode;
//   active?: boolean;
// }) => {
//   return (
//     <Button plain>
//       <Box
//         border={
//           active ? { side: "left", color: "brand", size: "4px" } : undefined
//         }
//         pad={{ vertical: "xsmall", left: "small" }}
//         margin={{ left: "small", vertical:"xsmall" }}
//       >
//         {children}
//       </Box>
//     </Button>
//   );
// };

export default Settings;
